import { render, staticRenderFns } from "./ChatSidebar.vue?vue&type=template&id=bf74404c&scoped=true"
import script from "./ChatSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChatSidebar.vue?vue&type=style&index=0&id=bf74404c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf74404c",
  null
  
)

export default component.exports